import { ObjectType } from '@ru-edu/ecl-player';
import { List } from './List';

export const TaskList = () => <List kind={ObjectType.Task} baseUrl="/tasks" />;
